/**
 * Farhod (2026-09-02): «SAV dan boshqa hamma kontragent, sklad, magazin
 * tizimiga kirganda "закупка завода" degan tushuncha o'rniga "закупка SAV"
 * qilib o'zgartir yozuvni».
 *
 * Sabab: zanjirda pastki bo'g'in uchun yuqoridagi bo'g'in ZAVOD emas —
 * u yetkazib beruvchi (SAV yoki uning kontragenti). Shuning uchun
 * bola tizimlarda bo'lim nomi yetkazib beruvchining haqiqiy nomi bilan
 * ko'rsatiladi. Glavniy tizimda (tenant 1) yozuv o'zgarmaydi — u yerda
 * haqiqatan ham zavoddan zakupka qilinadi.
 *
 * Yetkazib beruvchi nomi `authState.user.parentName` da keladi
 * (AccountAPI/MyPermissions → parentName).
 */
/** Ildiz tizimning bazadagi texnik nomlari — brend nomi bilan ko'rsatiladi. */
const ROOT_ALIASES = ["glavniy", "glavniy sklad", "главный склад", "главный", "main"]
const BRAND = "SAV"

export function applySupplierName(
  menuKey: string,
  label: string,
  user: any
): string {
  if (menuKey !== "factoryPurchases") return label
  const tenantId = Number(user?.tenantId || 1)
  if (tenantId <= 1) return label // glavniy tizim — «Закупка завода» to'g'ri
  let parent = (user?.parentName || "").toString().trim()
  if (!parent) return label
  // Ildiz tizim bazada «GLAVNIY» deb saqlanadi, foydalanuvchi esa uni
  // SAV deb biladi (Farhod, 2026-09-02). Zanjirning pastki bo'g'inlarida
  // esa ota tizimning O'Z nomi ko'rsatiladi.
  if (ROOT_ALIASES.includes(parent.toLowerCase())) parent = BRAND

  // «Закупка завода» / «Zavod zakupkasi» / «Factory purchases» —
  // uchala tilda ham «zavod» so'zi yetkazib beruvchi nomiga almashadi.
  const replaced = label
    .replace(/завода/gi, parent)
    .replace(/Zavod zakupkasi/gi, `${parent} zakupkasi`)
    .replace(/Factory purchases/gi, `${parent} purchases`)
  return replaced === label ? `${label} — ${parent}` : replaced
}
